import React from "react";

import { RemotesOperationsProviderAdapter } from "~/hooks/use-remotes-operations";

export function RemotesOperationsProvider({ children }: { children: React.ReactNode }) {
  return <RemotesOperationsProviderAdapter>{children}</RemotesOperationsProviderAdapter>;
}
